<template>
  <div class="body">
    <div class="title">
      活动资讯
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"  class="dsadf">
            <span class="dsadf">首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item>活动资讯</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <el-button type="primary" icon="el-icon-plus" size="medium" @click="routefabu">发布</el-button>
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="发布日期"
              @change="Discountsearch"
              v-model="Query.create_date"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="排序" v-model="Query.sortby" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="发布时间倒序 "></el-option>
              <el-option  name="selected" :value="1" label="活动时间倒序 "></el-option>
              <el-option  name="selected" :value="2" label="报名人数多优先 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 " v-model="Query.keyword" @input="Discountsearch" style="min-width: 168px;width: 336px;">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      border
      show-overflow
      keep-source
      ref="xTable"
      max-height="750"
      class="mytable-scrollbar"
      :data="tableData"
      align="center"
      :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="name" title="标题" width="200"></vxe-table-column>
      <vxe-table-column field="cover" title="封面" width="150">
        <template  slot-scope="scope">
          <img v-if="scope.row.cover" :src="$ReturnImgUrl(scope.row.cover)" alt="" style="width: 50px; height: 50px;">
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column field="area_name" title="地址" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.area_name }}{{ scope.row.town_name }}{{ scope.row.address }}
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="bus_org_com" title="发布人" width="200"></vxe-table-column>
      <vxe-table-column field="createtime" title="发布时间" width="200"></vxe-table-column>
      <vxe-table-column field="hits" title="浏览" width="100"></vxe-table-column>
      <vxe-table-column field="collects_num" title="收藏" width="100"></vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
            <div class="bfamsa">
              <!-- 查看详情 -->
              <button @click="chakanxiangqing(scope.row)" class="chakanxiangqinganniu">查看详情</button>
              <!--  删除  -->
              <button @click="shanchu(scope.row)" class="shanchuanniu">删除</button>
            </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15,20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { delPolicy, policyList } from '@/api/tiezi'

import { adminInfo } from "@/api/login";

export default {
  name: 'zhengcejiedu',
  data () {
    return {
      type: '',
      cur_page: 1,
      pageshow: true,
      tableData: [],
      total: null,
      Query: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        sortby: 0,
        keyword: '',
        page: 1,
        pagesize: 10
      }
    }
  },
  created () {
    this.getUserInfo();
    this.liebiao()
  },
  methods: {
    getUserInfo() {
      const obj = {
        token: sessionStorage.getItem("token"),
      };
      adminInfo(obj).then(({ data: res }) => {
        console.log("res", res);
        this.type = res.type;
      });
    },
    chakanxiangqing (row) {
      console.log('row', row)
      // this.$store.commit('setzhengceID', row.id)
      this.$router.push('/zhengcejieduxiangqing?id=' + row.id)
    },
    shanchu (row) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem('token'),
            id: row.id
          }
          delPolicy(obj).then(({ data: res }) => {
            console.log('res', res)
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              setTimeout(() => {
                window.sessionStorage.clear()
                this.$router.push('/login')
              }, 1000)
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              return false
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '2000'
              })
              this.Discountsearch()
            }
          })
        })
        .catch(() => {});
    },
    Discountsearch () {
      this.Query.page = 1
      this.cur_page = 1
      this.liebiao()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    handleSizeChange (val) {
      this.Query.pagesize = val
      this.handleCurrentChange(this.Query.page)
    },
    handleCurrentChange (val) {
      this.Query.page = val
      this.liebiao()
    },
    liebiao () {
      policyList(this.Query).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    routefabu () {
      this.$router.push('/zhengcejiedufabu')
    }
  }
}
</script>

<style scoped lang="less">
.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }

  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      flex:1;
      margin-right: 150px;
    }
    .right{
      margin-top: 27px;
    }
  }
  .bfamsa{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .chakanxiangqinganniu{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    border-radius: 2px;
    opacity: 1;
    font-size: 12px;
    background: white;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display:flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
  }
  .shanchuanniu{
    background: white;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(229,72,72,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #e54848;
    letter-spacing: 0px;
    display:flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
